import styled, { css } from 'styled-components/macro'
import { layout, space } from 'styled-system'
import { ColorsMap } from '@/utils/Theme'

export const Wrapper = styled.div`
  position: relative;
  width: 1rem;
  height: 1rem;
  ${layout}
  ${space}
`

export const StyledCheckbox = styled.input`
  cursor: pointer;
  color: ${ColorsMap.primary};
  appearance: none;
  border: 1px solid ${ColorsMap.textDefault};
  border-radius: 20%;
  width: 100%;
  height: 100%;
`

type TickProps = { checked: boolean }
export const Tick = styled.div<TickProps>`
  pointer-events: none;
  cursor: pointer;
  color: ${ColorsMap.textDefault};
  position: absolute;
  transition: all 0.3s ease;

  ${(props) => {
    if (props.checked) {
      return css`
        position: absolute;
        border: 2px solid ${ColorsMap.primary};
        border-top: none;
        border-right: none;
        content: '';
        top: 50%;
        left: 50%;
        height: 35%;
        width: 60%;
        opacity: 1;
        transform: translate(-50%, -50%) rotate(-45deg);
      `
    }
    return null
  }}
`

export const Label = styled.label`
  margin-left: 0.5rem;
`
